var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_63",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 312,
    height: 312
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 312,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_63)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: 128.827,
    width: 243,
    height: 45,
    transform: "rotate(-45 -48 128.827)",
    fill: "#af4154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1677 72.3431L37.4185 85.8347L35.0143 88.2389L21.5227 81.9881L23.6441 79.8667L34.2082 85.0003L29.0605 74.4503L31.1677 72.3431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9327 70.7742L38.4076 73.2491L41.731 69.9257L43.3007 71.4955L39.9773 74.8189L42.5936 77.4352L46.3413 73.6875L47.9535 75.2997L42.2259 81.0273L32.3406 71.1419L38.0681 65.4144L39.6804 67.0266L35.9327 70.7742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1956 65.0576L56.2157 67.0375L44.9586 64.7465L51.7327 71.5206L49.7528 73.5005L39.8674 63.6151L41.8473 61.6352L53.1186 63.9404L46.3304 57.1522L48.3103 55.1723L58.1956 65.0576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7317 49.7791C54.7688 48.742 55.8813 48.0349 57.0692 47.6578C58.2666 47.2713 59.4545 47.243 60.633 47.573C61.8115 47.8841 62.8958 48.5346 63.8857 49.5246C64.8757 50.5145 65.5262 51.5988 65.8373 52.7773C66.1485 53.9369 66.1108 55.1154 65.7242 56.3128C65.3471 57.5007 64.64 58.6133 63.6029 59.6503L60.1522 63.101L50.281 53.2298L53.7317 49.7791ZM61.8493 58.0381C62.8863 57.001 63.4049 55.9168 63.4049 54.7854C63.4049 53.6541 62.8911 52.5746 61.8634 51.5469C60.8357 50.5192 59.7515 50.0007 58.6107 49.9913C57.4605 49.9724 56.3668 50.4815 55.3297 51.5186L53.9297 52.9187L60.4492 59.4382L61.8493 58.0381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3696 41.1412L68.479 47.2506C69.1484 47.92 69.8367 48.2594 70.5438 48.2688C71.2415 48.2688 71.9062 47.953 72.5378 47.3213C73.1789 46.6802 73.4995 46.0108 73.4995 45.3131C73.4901 44.606 73.1507 43.9177 72.4813 43.2483L66.3719 37.1389L68.3659 35.1449L74.4612 41.2402C75.3003 42.0793 75.8282 42.9749 76.0451 43.9272C76.2619 44.8605 76.2101 45.7798 75.8895 46.6849C75.5784 47.5805 75.0504 48.4008 74.3056 49.1456C73.5702 49.881 72.7547 50.4043 71.859 50.7154C70.9728 51.0171 70.0677 51.0548 69.1437 50.8285C68.2103 50.5928 67.3241 50.0554 66.485 49.2163L60.3897 43.1211L62.3696 41.1412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0387 27.1327L82.6431 34.1896L80.9743 35.8584L73.9032 29.2682L76.0387 27.1327ZM85.1604 38.2909C84.8021 38.6491 84.3967 38.8377 83.9441 38.8565C83.4916 38.8565 83.1003 38.6915 82.7703 38.3616C82.4404 38.0316 82.2801 37.645 82.2895 37.2019C82.2989 36.7399 82.4828 36.3298 82.841 35.9715C83.1899 35.6227 83.5906 35.4483 84.0431 35.4483C84.4862 35.4389 84.8728 35.5991 85.2028 35.9291C85.5328 36.2591 85.6978 36.6504 85.6978 37.1029C85.6883 37.546 85.5092 37.942 85.1604 38.2909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5011 22.0538L-41.636 135.191",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.865 15.6897L73.6223 19.9324",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7818 103.371L34.0244 99.1284",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1076 11.4473L79.9863 13.5686",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5391 107.614L27.6604 105.492",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.99 -16.8371L36.1458 97.0071",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSold);
export default __webpack_public_path__ + "static/media/sold.285fcb22c77a5efd3ab99ff57276575f.svg";
export { ForwardRef as ReactComponent };